/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Outstanding_DebtInputs */

const vi_customer_outstanding_debt = /** @type {(inputs: Customer_Outstanding_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ (VND)`)
};

/**

* @param {Customer_Outstanding_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_outstanding_debt = /** @type {((inputs?: Customer_Outstanding_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Outstanding_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_outstanding_debt(inputs)
});